import React from "react";
import SweetAlert from 'sweetalert2';
import { toast } from "react-toastify";

const changeStatus = async (data, refresh, updateStatus, newStatus, modelId) => {
  try {
    const is_active = String(newStatus).toLowerCase() === 'active' || String(newStatus) === '1' || newStatus === 1 || newStatus === true;
    const updateData = { is_active, status: is_active ? 'Active' : 'Deactivate' };
    const result = await SweetAlert.fire({
      title: 'Are you sure?',
      text: `Are you sure you want to change the status to "${newStatus}"?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'YES',
      cancelButtonText: 'NO',
      reverseButtons: true,
    });

    if (result.value) {
      await updateStatus(modelId, updateData);
      refresh();
    } else {
      toast.info('Status is safe');
    }
  } catch (error) {
    toast.error(error?.response?.data || 'An error occurred');
  }
};


const StatusCells = ({ row, refresh, updateStatus, dataId, checkAccess }) => {
  
  const normalizeIsActive = (val) => {
    if (val === true || val === 1) return true;
    if (String(val).toLowerCase() === '1' || String(val).toLowerCase() === 'true' || String(val).toLowerCase() === 'active') return true;
    return false;
  };

  const handleChangeStatus = async (e, data) => {
    const newStatus = e?.target?.value;
    changeStatus(data, refresh, updateStatus, newStatus, dataId);
  };

  // const canAllowUpdate = checkAccess();
  // const canAllowUpdate = checkAccess ? checkAccess() : null;
  const canAllowUpdate = checkAccess !== undefined ? checkAccess() : true;
  const editDisabled = !canAllowUpdate;

  return (
    <div>
      {editDisabled ? (
        <span className={`badge ${normalizeIsActive(row.original.is_active) ? 'badge-success' : 'badge-danger'}`}>
          {normalizeIsActive(row.original.is_active) ? 'Active' : 'Deactivate'}
        </span>
      ) : (
      <select
        className={`mui-datatable-select ${
          normalizeIsActive(row.original.is_active)
            ? "select-active"
            : "select-deactivated"
        }`}
        onChange={(e) => handleChangeStatus(e, row.original)}
        value={normalizeIsActive(row.original.is_active) ? "Active" : "Deactivate"}
        disabled={editDisabled}
      >
        <option
          value="Active"
          disabled={normalizeIsActive(row.original.is_active)}
        >
          Active
        </option>
        <option
          value="Deactivate"
          disabled={!normalizeIsActive(row.original.is_active)}
        >
          Deactivate
        </option>
      </select>
       )}
    </div>
  );
};

export default StatusCells;
